import { render, staticRenderFns } from "./review-batch-match-order.vue?vue&type=template&id=1e2f1cc8&scoped=true&"
import script from "./review-batch-match-order.vue?vue&type=script&lang=js&"
export * from "./review-batch-match-order.vue?vue&type=script&lang=js&"
import style0 from "./review-batch-match-order.vue?vue&type=style&index=0&id=1e2f1cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f1cc8",
  null
  
)

export default component.exports